<template>
  <a-tabs
      v-model:activeKey="searchForm.status"
      style="background-color: #fff; padding: 0 12px"
      @change="getTableData()"
  >
    <a-tab-pane key="0" tab="全部"></a-tab-pane>
    <a-tab-pane key="1" tab="待收"></a-tab-pane>
    <a-tab-pane key="2" tab="待退"></a-tab-pane>
    <a-tab-pane key="3" tab="已退"></a-tab-pane>
  </a-tabs>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 到期提示 -->
    <div v-if="isExpired" class="expire-banner">
      <div class="expire-banner-content">
        <span class="expire-banner-title">房源已到期</span>
        <span class="expire-banner-info">到期时间：{{ expireDate }}</span>
        <span class="expire-banner-renew">续费路径：手机端 我的->房源管理->购买付费</span>
      </div>
    </div>
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-select
                v-model:value="searchForm.dateType"
                placeholder="类型"
                @change="getTableData"
            >
              <a-select-option :value="1">入住日期</a-select-option>
              <a-select-option :value="2">退房日期</a-select-option>
            </a-select>
          </div>
          <div class="group-one" style="width: 220px">
            <a-range-picker
                v-model:value="rangePicker"
                :ranges="ranges"
                @change="handlePicker"
            />
          </div>
        </div>
        <div class="lef-one">
          <a-select
              v-model:value="searchForm.deduction"
              placeholder="类型"
              @change="getTableData"
          >
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">有扣款</a-select-option>
            <a-select-option :value="2">无扣款</a-select-option>
          </a-select>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.order_no"
              allowClear placeholder="订单号|外部单号"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.pay_no"
              allowClear placeholder="商户单号"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.keyword"
              :loading="searchLoading"
              placeholder="房间名称/客人/手机号"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-popover
              v-model:visible="visiblePopover"
              placement="bottom"
              trigger="click"
          >
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button
                  size="small"
                  style="margin-right: 5px"
                  @click="handleResetCheck"
              >重置
              </a-button
              >
              <a-button :disabled="isExpired" class="btn-primary" size="small" @click="handleCheck"
              >确认
              </a-button
              >
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
        <div class="rig-one">
          <a-button>
            <upload-outlined/>
            导出
          </a-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 8 ? columns.length*130 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
              :disabled="isExpired"
              type="link"
              @click="
              detShow = true;
              orderId = record.order_id;
            "
          >{{ record.order_no }}
          </a-button
          >
        </template>
        <template v-if="column.key == 'checkIn'">
          <div>{{ record.tname }}-{{ record.tphone }}</div>
        </template>
        <template v-if="column.key == 'operate'">
          <a-button
              v-if="
              record.status == 2 &&
              record.refund_status !== 2 &&
              record.refund_status !== 3
            "
              :disabled="isExpired"
              class="f-c-red"
              type="link"
              @click="openRefund(record)"
          >退款
          </a-button
          >
          <a-button
              v-if="record.status == 1"
              :disabled="isExpired"
              type="link"
              @click="depositFree(record)"
          >免押
          </a-button
          >
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />

    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />

    <!-- 退款 -->
    <a-modal
        v-model:visible="showRefund"
        :width="500"
        class="refund"
        title="退款"
        @ok="refundSave"
    >
      <a-form
          ref="formRefund"
          :label-col="{ span: 4 }"
          :model="currentItem"
          labelAlign="left"
      >
        <a-form-item label="收款金额：">
          <!-- <a-input v-model:value="currentItem.amount" disabled /> -->
          <div>
            {{ currentItem.amount }}
          </div>
        </a-form-item>
        <a-form-item label="收款时间：">
          <!-- <a-input v-model:value="currentItem.refund_time" disabled /> -->
          <div>
            {{ currentItem.pay_time }}
          </div>
        </a-form-item>
        <a-form-item label="退押方式：">
          <div class="refund-switch">
            <div
                :class="{ refundSel: currentItem.refund_type == 1 }"
                class="switch-lef"
                @click="
                currentItem.refund_type = 1;
                currentItem.refund_amount = currentItem.amount;
              "
            >
              全额退款
            </div>
            <div
                :class="{ refundSel: currentItem.refund_type == 2 }"
                class="switch-rig"
                @click="
                currentItem.refund_type = 2;
                currentItem.refund_amount = '';
              "
            >
              非全额退款
            </div>
          </div>
        </a-form-item>
        <a-form-item
            :rules="[{ required: true, message: '请输入金额', type: 'blur' }]"
            label="金额："
        >
          <a-input
              v-model:value="currentItem.refund_amount"
              :disabled="currentItem.refund_type == 1"
              placeholder="请输入退款金额, 0表示不退"
              type="number"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {getCompanyConfig, orderDepositEdit, orderDepositList, orderDepositRefund,} from "@/api/api";
import dayjs from "dayjs";
import {AppstoreOutlined, ExclamationCircleOutlined, UploadOutlined,} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import {message, Modal} from "ant-design-vue";
import store from "@/store/pms/landlord/index";

export default {
  components: {
    UploadOutlined,
    AppstoreOutlined,
    OrderDetails,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      isExpired: false,
      expireDate: "",
      searchForm: {
        status: 0,
        deduction: 0,
        keyword: "",
        pay_no: "",
        order_no: "",
        start: 0,
        limit: 20,
        startDate: "",
        endDate: "",
        dateType: 1,
      },
      rangePicker: [],
      visiblePopover: false,
      ranges: {
        昨天: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
        今天: [dayjs(), dayjs()],
        明天: [dayjs().add(1, "day"), dayjs().add(1, "day")],
        最近7天: [dayjs().subtract(7, "day"), dayjs()],
        最近30天: [dayjs().subtract(30, "day"), dayjs()],
        上月: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
        本月: [dayjs().startOf("month"), dayjs().endOf("month")],

        上季度: [
          dayjs().startOf("month").add(-1, "year").month(9),
          dayjs().endOf("month").add(-1, "year").month(11),
        ],
        本季度: [
          dayjs().startOf("month").month(0),
          dayjs().endOf("month").month(2),
        ],
      },
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handlePicker(_params, value) {
        search.searchForm.startDate = value[0];
        search.searchForm.endDate = value[1];
        table.getTableData();
      },
      handleReset() {
        search.rangePicker = [];
        search.searchForm.dateType = 1;
        search.searchForm.keyword = "";
        search.searchForm.order_no = "";
        search.searchForm.pay_no = "";
        search.searchForm.startDate = "";
        search.searchForm.endDate = "";
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      checkCompanyConfig() {
        getCompanyConfig()
          .then((res) => {
            const data = res.data || {};
            // data.expire = true; // TODO: 临时测试，记得删除
            if (data.expire) {
              search.isExpired = true;
              search.expireDate = data.house_expire_time ? dayjs(data.house_expire_time * 1000).format("YYYY-MM-DD") : "";
            } else {
              search.isExpired = false;
              search.expireDate = "";
            }
            table.getTableData();
          })
          .catch(() => {
            search.isExpired = false;
            search.expireDate = "";
            table.getTableData();
          });
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    function getColumns() {
      return [
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          width: 150,
          isShow: true,
        },
        {
          title: "商户单号",
          dataIndex: "payNo",
          key: "payNo",
          width: 150,
          isShow: true,
        },
        {
          title: "房号",
          dataIndex: "name",
          key: "name",
          isShow: true,
          ellipsis: true,
        },
        {
          title: "入住时间",
          dataIndex: "start_date",
          key: "start_date",
          width: 200,
          customRender: ({record}) => {
            return record.start_date + " - " + record.end_date;
          },
          isShow: true,
        },
        {
          title: "客人",
          dataIndex: "checkIn",
          key: "checkIn",
          isShow: true,
          ellipsis: true,
        },
        {
          title: "押金（元）",
          dataIndex: "amount",
          key: "amount",
          width: 100,
          isShow: true,
        },
        {
          title: "已退（元）",
          dataIndex: "refund_amount",
          key: "refund_amount",
          width: 100,
          isShow: true,
        },
        {
          title: "支付时间",
          dataIndex: "pay_time",
          key: "pay_time",
          width: 150,
          isShow: true,

        },
        {
          title: "退款时间",
          dataIndex: "refund_time",
          key: "refund_time",
          width: 150,
          isShow: true,
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          width: 100,
          customRender: ({record}) => {
            if (record.status == 1) {
              return record.status_text;
            } else if (record.status == 2 && record.refund_status == 0) {
              return record.status_text;
            } else if (record.status == 2 && record.refund_status != 0) {
              return record.refund_status_text;
            }
          },
          isShow: true,
        },
        {
          title: "",
          dataIndex: "operate",
          key: "operate",
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      // 免押
      depositFree(item) {
        Modal.confirm({
          title: "确认免押吗?",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            orderDepositEdit({
              depositId: item.id,
              amount: 0,
            }).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        orderDepositList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              nextTick(() => {
                table.columns = getColumns();
                table.initColumns = getColumns();
              });
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: [
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          width: 150,
        },
        {
          title: "商户单号",
          dataIndex: "payNo",
          key: "payNo",
          width: 150,
        },
        {
          title: "房号",
          dataIndex: "name",
          key: "name",
          width: 200,
        },
        {
          title: "入住时间",
          dataIndex: "start_date",
          key: "start_date",
          width: 200,
        },
        {
          title: "客人",
          dataIndex: "checkIn",
          key: "checkIn",
          width: 200,
        },
        {
          title: "押金（元）",
          dataIndex: "amount",
          key: "amount",
          width: 100,
        },
        {
          title: "已退（元）",
          dataIndex: "refund_amount",
          key: "refund_amount",
          width: 100,
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          width: 100,
          customRender: ({record}) => {
            if (record.status == 1) {
              return record.status_text;
            } else if (record.status == 2 && record.refund_status == 0) {
              return record.status_text;
            } else if (record.status == 2 && record.refund_status != 0) {
              return record.refund_status_text;
            }
          },
        },
        {
          title: "",
          dataIndex: "operate",
          key: "operate",
          width: 200,
        },
      ],
    });

    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableData();
      },
    });

    // 退款
    const refund = reactive({
      formRefund: "",
      showRefund: false,
      openRefund(item) {
        table.currentItem = item;
        table.currentItem.refund_type = 1;
        table.currentItem.refund_amount = item.amount;
        refund.showRefund = true;
      },
      refundSave() {
        refund.formRefund.validate().then(() => {
          orderDepositRefund({
            depositId: table.currentItem.id,
            refundPrice: table.currentItem.refund_amount,
            refundType: table.currentItem.refund_type,
          }).then((res) => {
            message.success(res.msg);
            refund.showRefund = false;
            table.getTableData();
          });
        });
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 70;
        }
    );

    onMounted(() => {
      search.checkCompanyConfig();
      table.tableHeight = countTable(search.topDom) - 70;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
      ...toRefs(refund),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.expire-banner {
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 12px;

  .expire-banner-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;

    .expire-banner-title {
      color: #cf1322;
      font-size: 16px;
      font-weight: bold;
    }

    .expire-banner-info {
      color: #cf1322;
      font-size: 14px;
    }

    .expire-banner-renew {
      color: #595959;
      font-size: 14px;
    }
  }
}
</style>
